module.exports = __webpack_public_path__ + "img/logo.47809a83.png";